// janus-engine/combat/turn-navigation.ts — the GM's turn NAVIGATION decided in the browser (2026-09-30: no PHP fallback, one copy).
//
// previous — the rule of options/game/turns/previous_turn_inc.php (deleted): a LEGENDARY interlude first rewinds to the Main Turn that
//            opened it (pending_main; the phase resets to main), then the pointer steps back one slot in the initiative walk. From the
//            FIRST creature it unwraps the round: round − 1 (never below 1 — "Cannot move before round 1!"), the pointer to the LAST
//            creature, and the campaign clock pulled back one round (6 s). A pointer outside the walk refuses (re-anchor with Go To).
// goto     — go_to_creature_turn_inc.php (deleted): the pointer onto the chosen member; never crosses a round. In a legendary interlude
//            it ends the interlude (phase back to main), exactly as Previous Turn's rewind does.
// Pure: the order, pointer, round and phase in; the decision out. The combat-truth lane posts it; PHP saves.

export interface TurnState { order: string[]; pointer: string; round: number; phase: string; pendingMain: string }
export type NavDecision =
  | { ok: true; pointer: string; round: number; phaseReset: boolean; pullRounds: number }
  | { ok: false; reason: string; message: string };

const upper = (v: unknown): string => String(v ?? '').trim().toUpperCase();
const UUID = /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/;

export function resolvePreviousTurn(state: TurnState): NavDecision {
  const order = state.order.map(upper);
  let pointer = upper(state.pointer);
  let phaseReset = false;
  if (state.phase === 'legendary') {
    const pending = upper(state.pendingMain);
    if (!UUID.test(pending)) return { ok: false, reason: 'legendary-no-pending', message: 'The Legendary Turn has no valid pending Main Turn to rewind from. Use Go To Creature Turn to set the turn.' };
    pointer = pending;
    phaseReset = true;
  }
  if (order.length === 0) return { ok: false, reason: 'initiative-empty', message: 'There are no creatures in the initiative order to move back to.' };
  const at = order.indexOf(pointer);
  if (at < 0) return { ok: false, reason: 'pointer-not-in-order', message: 'The current turn marker no longer matches a creature in the initiative order (it may have died or been removed). Use Go To Creature Turn to set the turn, then try again.' };
  if (at > 0) return { ok: true, pointer: order[at - 1]!, round: state.round, phaseReset, pullRounds: 0 };
  const round = state.round - 1;
  if (round < 1) return { ok: false, reason: 'before-round-1', message: 'Cannot move before round 1!' };
  return { ok: true, pointer: order[order.length - 1]!, round, phaseReset, pullRounds: 1 };
}

export function resolveGotoTurn(state: TurnState, target: string): NavDecision {
  const id = upper(target);
  if (!UUID.test(id)) return { ok: false, reason: 'target', message: 'No target selected to move to!' };
  return { ok: true, pointer: id, round: state.round, phaseReset: state.phase === 'legendary', pullRounds: 0 };
}
